import $ from 'jquery';

export function load() {
  $(function () {
    $('li.dropdown').on({
      mouseenter: function () {
        $('li.dropdown ul').attr('aria-hidden', 'false'),
          $('li.dropdown > a').attr('aria-expanded', 'true');
      },
      mouseleave: function () {
        $('li.dropdown ul').attr('aria-hidden', 'true'),
          $('li.dropdown > a').attr('aria-expanded', 'false');
      },
      focusin: function () {
        $('li.dropdown ul').attr('aria-hidden', 'false'),
          $('li.dropdown > a').attr('aria-expanded', 'true');
      },
      focusout: function () {
        $('li.dropdown ul').attr('aria-hidden', 'true'),
          $('li.dropdown > a').attr('aria-expanded', 'false');
      },
    });

    $('#menutoggle').on('click', function () {
      $('#nav-icon3').toggleClass('open');
      $('.hend-nav').toggleClass('opened');
      $('#navbarSupportedContent').slideToggle();

      $('#menutoggle').attr('aria-expanded', $('.hend-nav').hasClass('opened'));
    });
  });
}
